/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-confirmed': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm0-2a9 9 0 100-18 9 9 0 000 18zm3.293-12.707L9 12.586l-2.293-2.293-1.414 1.414L9 15.414l6.707-6.707-1.414-1.414z" _fill="#005BA5"/>'
  }
})
